module.exports = __webpack_public_path__ + "web.config";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=[name].[ext]!./app/web.config
// module id = ./node_modules/file-loader/index.js?name=[name].[ext]!./app/web.config
// module chunks = 7